module.exports = __webpack_public_path__ + "img/alan-garcia.29551600.png";